module.exports={turnstile_modal:{message:"Sicherheitsdetails werden geprüft"}};